<template>
  <basic-container>
    <div class="masterfundDetail" id='masterFundRoot'>
      <div class="bankdetail_title">
        <div class="banktail_">
        <!-- 头部 -->
        <div class="top-line">
          <div class="changeblock">
            <!-- <div>
              <div class="historyclass orange" v-if="data.auditState && data.auditState == '1'">
                审核中
              </div>
              <div class="historyclass" v-if="data.auditState && data.auditState == '2'">
                {{ data.auditTime ? data.auditTime.substr(0, 10) : "" }} 审核通过
              </div>
            </div> -->
            <div class="project-title">{{ data.name }}</div>
          </div>

        </div>

          <!-- <div class="project-status">
            <div class="status-title">审核状态</div>
            <div class="status-content" :class="['stateTopdiv', 'color_' + data.auditState]">
              {{data.auditStateStr}}
              <span v-if="data.auditLog != '' && data.auditState == 0">
                <i class="el-icon-warning-outline" style="font-size:14px" @click="warningblock"></i>
              </span>
            </div>
          </div> -->
          
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane class="activelabel" label="基金信息" name="first">

              <InfoContainer
                :infoTitle="formConfig['infoTitle']"
                :contentConfig="formConfig['infoContent']"
                class="comment-container"
              >
                <CommonDetail
                  :configArray="extraFormConfig"
                  :initValue="data"
                />
              </InfoContainer>

              <Accessory
                fileTitle="设立文件"
                idname="设立文件"
                :upload="data.auditState <1 && data.managerUser == userInfo.user_id"
                :projectid="id"
                :fileMenuUrlname="`基金业务-出资主体`"
              />

              <!-- 投资动态 -->
              <InvestEventManage :ids="$route.params.id" :edit="permission.otherFund_edit?true: false"/>
            </el-tab-pane>
            <el-tab-pane
              class="activelabel"
              label="关联基金"
              name="affiliatedfund"
            >
              <Item title="基金信息" :option="affiliatedOption" :itemDate="affiliateditemDate" />

            </el-tab-pane>
            
            <!-- v-if="data.auditState >= '2'" -->
            <el-tab-pane
              class="activelabel"
              label="关联项目"
              name="associateditems"
            >
              <Item
                title="项目信息"
                :option="associateditemsOption"
                :itemDate="associateditemsitemDate"
              />
              </el-tab-pane
            >

            <!-- <el-tab-pane class="activelabel" label="附件信息" name="second">
              <Accessory
                idname="母基金文件"
                :showTitle="false"
                :upload="
                  data.auditState <1 && data.managerUser == userInfo.user_id
                "
                :projectid="data.id"
                fatername="母基金管理"
              />

              </el-tab-pane
            > -->
          </el-tabs>


        </div>
      </div>
      <div>
        <Dialog :data="data" ref="dialogpass" />

        <!-- <History ref="history" @bankhistory="bankhistory" /> -->
        <Dialogreason
          :passdata="passdata"
          @passcheck="passcheck"
          ref="reasondialog"
        />
      </div>
      <!-- <div class="history" v-if="history>1">
        <div class="history_content" @click="historyHome">
          <div class="imagehistory">
            <el-image src="/img/bg/u3205.svg"></el-image>
          </div>

          <div class="text_history">历史版本</div>
        </div>
      </div> -->
    </div>
    <div class="bottom-container" v-if="permission.otherFund_edit ">
      <div class="button-container">
        <!-- <el-button
          v-if="data.auditState == 0 && userInfo.user_id == data.managerUser && permission.otherFund_edit"
          type="primary"
          @click="updatastate()"
        >
          提交审核
        </el-button> -->
        <el-button
          plain
          type="primary"
          @click="goEdit()"
        >
          编辑
        </el-button>
      </div>
    </div>
    <!-- <div class="bottom-container" v-if="data.auditState && data.auditState == 1 && permission.otherFund_audit ">
      <div class="button-container">      
        <el-button
          type="primary"
          icon="el-icon-check"
          plain
          @click="auditNext(data.id, true)"
        >
          通过
        </el-button>
        <el-button
          type="warning"
          icon="el-icon-close"
          plain
          @click="auditNext(data.id, false)"
        >
          退回
        </el-button>
      </div>
    </div> -->

    <!-- 电梯 -->
    <!-- <NavigatorBar
      v-if="activeName == 'first'"
      :buttonConfig="buttonConfig"
      rootId="masterFundRoot"
    /> -->
  </basic-container>
</template>

<script>
import InfoContainer from "@/components/infoContainer/fundInfoContainer";
import BusinessDescriptions from "@/components/fundComponent/businessDescriptions";
import Usermanage from "./components/usermanage.vue";
import CommonDetail from "@/components/commonDetail/fundCommonDetail"
import Details from "@/components/detail/rzzl_lxj/detail";
import NavigatorBar from "@/components/navigatorBar/navigatorBar";
import Detaillist from "@/components/detail/detaillist";
import * as api from "@/api/fund/masterfund";
import { queryEventLists } from "@/api/fund/fundProject";
import History from "./components/history";
import Dialogreason from "@/components/detail/rzzl_lxj/reason";
import Accessory from "@/components/accessoriesother/fundAccessory";
import Item from "./components/items.vue";
import { mapGetters } from "vuex";
import Dialog from "@/components/detail/rzzl_lxj/dialog";
import InvestEventManage from "../../masterfund/components/invesEventtManage";
import util from "@/mixins/util"
export default {
  name: "masterfundDetail",
  mixins: [util],
  data() {
    return {
      id: '',
      buttonConfig:[
        {
          id: 'el1',
          name: '项目立项'
        },        {
          id: 'el2',
          name: '中介采购'
        },        {
          id: 'el3',
          name: '尽职调查'
        },        {
          id: 'el4',
          name: '投资建议书'
        },        {
          id: 'el5',
          name: '项目方案'
        },        {
          id: 'el6',
          name: '投资决策'
        },        {
          id: 'el7',
          name: '投资协议'
        },        {
          id: 'el8',
          name: '投放审核'
        },
      ],
      activeName: "first",
      data: {
        manager:{}
      },

      history:'',
      passdata: {
        id: "",
        auditAdvise: "",
        pass: false,
      },
      butshengheloading: false,
      examine: true,
      affiliateditemDate: [],
      affiliatedOption: {
        searchIcon: true,
        addBtn: false,
        delBtn: false,
        columnBtn: false,
        refreshBtn: false,
        editBtn: false,
        border: false,
        menu: false,
        // fit: true,
        column: [
          {
            label: "子基金名称",
            prop: "name",
            // width: 180,
            slot:true
          },
          {
            label: "合作方式",
            prop: "cooperateType",
            type: 'select',
            dataType: 'string',
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=cooperate_type",
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            width: 100,
          },
          {
              label: "基金类型",
              // prop: "fundType",
              prop:'isDirectional',
              
              type: 'select',
              dataType: 'string',
              dicUrl: "/api/blade-system/dict-biz/dictionary?code=subFund_type",
              props: {
                label: "dictValue",
                value: "dictKey"
              },
              width: 100,        
            }, 
          // {
          //   label: "审核状态",
          //   prop: "auditState",
          //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_state",
          //   props: {
          //     label: "dictValue",
          //     value: "dictKey",
          //   },
          //   dataType: "string",
          // },          
          // {
          //   label: "基金规模",
          //   prop: "peScale",
          //   width: 150,
          //   formatter: (row, value, label, column) => {
          //     return this.getMoney(value) + " 元";
          //   },
          // },
          {
            label: "基金管理人",
            
            prop: "fdManagerName",
          },          
          {
            label: "认缴金额",
            prop: "govIndustrySubscribed",
            formatter: (row, value, label, column) => {
              return  value?this.getMoney(value) + " 元":'';
            },
            width: 200,
          },
          {
            label: "实缴金额",
            prop: "totalCapitalPaid",
            formatter: (row, value, label, column) => {
              return  value?this.getMoney(value) + " 元":'';
            },
            width: 200,
          }
        ],
      },
      associateditemsitemDate: [],
      associateditemsOption: {
        searchIcon: true,
        addBtn: false,
        delBtn: false,
        columnBtn: false,
        refreshBtn: false,
        editBtn: false,
        border: false,
        menu: false,
        // fit: true,
        column: [
          {
            label: "项目名称",
            prop: "projectName",
            slot: true,
            width: 200,
          },
          {
            label: "基金管理人",
            prop: "managerName",
            width: 150,
          },

          {
            label: "基金投资金额",
            prop: "fundAmount",
            width: 200,
            formatter: (row, value, label, column) => {
              return  value?this.getMoney(value) + " 元":'';
            },
          },
          // {
          //   label: "带动社会投资额",
          //   prop: "societyAmount",
          //   width: 200,
          //   formatter: (row, value, label, column) => {
          //     return this.getMoney(value) + " 元";
          //   },
          // },
          {
            label: "客户名称",
            prop: "custName",
            slot: true,
            // width:245,

            // slot: true,
          },
        ],
      },
      eventList: [],
      eventListOption: {
        searchIcon: true,
        addBtn: false,
        delBtn: false,
        columnBtn: false,
        refreshBtn: false,
        editBtn: false,
        border: false,
        menu: false,
        // fit: true,
        column: [
          {
            label: "动态名称",
            prop: "eventName",
            slot: true,
          },
          {
            label: "动态编号",
            prop: "number",
          },
          {
            label: "日期",
            prop: "eventTime",
          },

        ],
      },

      detaildeta: {
        edit: "permission.master_edit",
        // add: "permission.master_edit",
        // audit: "permission.master_audit",
        title: "data.name",
        biangeng: "that.data.auditState==2",
        topclass: false
      },
      detaillist: {
        column: [
          {
            label: "设立时间",
            prop: "establishmentTime",
          },
          {
            label: "基金规模",
            prop: "peScale",
            formatter: () => {
              if (this.data.peScale == -1) {
                return "";
              } else {
                return this.getMoney(this.data.peScale) + " 元";
              }
            },
          },
          {
            label: "基金管理人",
            prop: "managerName",
          },
          {
            label: "基金已投金额",
            prop: "allFundAmount",
            formatter: () => {
              if (this.data.allFundAmount == -1) {
                return "";
              } else {
                return this.getMoney(this.data.allFundAmount) + " 元";
              }
            },
          },
          {
            label: "基金实缴金额",
            prop: "totalCapitalPaid",
            formatter: () => {
              if (this.data.totalCapitalPaid == -1) {
                return "";
              } else {
                return this.getMoney(this.data.totalCapitalPaid) + " 元";
              }
            },
          },

          {
            label: "金投股权出资比例",
            prop: "capitalRatio",
            formatter: () => {
              if (this.data.capitalRatio == -1) {
                return "";
              } else {
                return this.getMoney(this.data.capitalRatio) + " %";
              }
            },
          },
        ],
        showcolumn: [
          {
            label: "审核状态",
            prop: "auditState",
            show: "pageData.auditState<-8",
            auditlog: true,
            state: 0,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_state",
          },
        ],
        firstsblock: {
          formatter: () => {
            return  this.data.auditState>1
              ? 23
              : 21;
          },
        },
        sentersblock: {
          formatter: () => {
            return  this.data.auditState> "0"
              ? 1
              : 3;
          },
        },

        firstrow: {
          formatter: () => {
            return {
              width: "35%",
            };
          },
        },
        secondrow: {
          formatter: () => {
            return {
              width: "35%",
            };
          },
        },
        thirdrow: {
          formatter: () => {
            return {
              width: "30%",
            };
          },
        },
      },
      basicIinformation: {
        column: [
          {
            label: "出资主体名称",
            prop: "name",
          },
          {
            label: "设立时间",
            prop: "establishmentTime",
            //  dicUrl: "/api/blade-system/dict-biz/dictionary?code=payment_type",
          },
          {
            label: "注册资本",
            prop: "peScale",
            formatter: () => {
              if (this.data.peScale == -1) {
                return "";
              } else {
                return this.getMoney(this.data.peScale) + " 元";
              }
            },
          },
          {
            label: "基金实缴金额",
            prop: "totalCapitalPaid",
            formatter: () => {
              if (this.data.allFundAmount == -1) {
                return "";
              } else {
                return this.getMoney(this.data.totalCapitalPaid) + " 元";
              }
            },
          },
          {
            label: "直投规模",
            prop: "directInvestScale",
            formatter: () => {
              if (this.data.directInvestScale == -1) {
                return "";
              } else {
                return this.getMoney(this.data.directInvestScale) + " 元";
              }
            },
          },
          {
            label: "合作基金认缴",
            prop: "cooperationFundSubscribed",
            formatter: () => {
              if (this.data.cooperationFundSubscribed == -1) {
                return "";
              } else {
                return this.getMoney(this.data.cooperationFundSubscribed) + "元";
              }
            },
          },
          {
            label: "实缴规模",
            prop: "cooperationFundPaid",
            formatter: () => {
              if (this.data.cooperationFundPaid == -1) {
                return "";
              } else {
                return this.getMoney(this.data.cooperationFundPaid) + "元";
              }
            },
          },
          {
            label: "合作基金已投金额",
            prop: "cooperationFundInvested",
            formatter: () => {
              if (this.data.cooperationFundInvested == -1) {
                return "";
              } else {
                return this.getMoney(this.data.cooperationFundInvested) + "元";
              }
            },
          },
          {
            label: "实缴规模",
            prop: "cooperationFundPaid",
            formatter: () => {
              if (this.data.cooperationFundPaid == -1) {
                return "";
              } else {
                return this.getMoney(this.data.cooperationFundPaid) + " 元";
              }
            },
          },                    
          {
            label: "金投方出资比例",
            prop: "capitalRatio",
            formatter: () => {
              if (this.data.capitalRatio == -1) {
                return "";
              } else {
                return this.getMoney(this.data.capitalRatio) + " %";
              }
            },
          },
          {
            label: "基金管理人",
            prop: "managerName",
          },
          {
            label: "投后报告周期",
            prop: "manageCycle",
            dicUrl:
              "/api/blade-system/dict-biz/dictionary?code=reportcycle_managecycle",
          },
        ],
        firstsblock: {
          formatter: () => {
            return 24;
          },
        },
        sentersblock: {
          formatter: () => {
            return 0;
          },
        },

        firstrow: {
          formatter: () => {
            return {
              width: "35%",
            };
          },
        },
        secondrow: {
          formatter: () => {
            return {
              width: "35%",
            };
          },
        },
        thirdrow: {
          formatter: () => {
            return {
              width: "30%",
            };
          },
        },
      },
      fundManager: {
        column: [
          {
            label: "基金管理人名称",
            prop: "managerName",
          },
          {
            label: "成立时间",
            prop: "manager.establishmentTime",
            //  formatter: () => {
            //   return manager.region.toString();
            // },
            //  dicUrl: "/api/blade-system/dict-biz/dictionary?code=payment_type",
          },
          {
            label: "所在地区",
            prop: "manager.region",
          },
          {
            label: "所在地址",
            prop: "manager.address",
          },
          {
            label: "纳税识别号",
            prop: "manager.creditCode",
          },
          {
            label: "基金协会编码",
            prop: "manager.orgCode",
          },
          {
            label: "联系人",
            prop: "manager.contactPerson",
          },
          {
            label: "联系号码",
            prop: "manager.contactInfo",
          },
          {
            label: "职务信息",
            prop: "manager.duty",
          },
        ],
        firstsblock: {
          formatter: () => {
            return 24;
          },
        },
        sentersblock: {
          formatter: () => {
            return 0;
          },
        },

        firstrow: {
          formatter: () => {
            return {
              width: "35%",
            };
          },
        },
        secondrow: {
          formatter: () => {
            return {
              width: "35%",
            };
          },
        },
        thirdrow: {
          formatter: () => {
            return {
              width: "30%",
            };
          },
        },
      },
      extraFormConfig: [
        {
          label: "出资主体名称",
          prop: 'name',
          span: '8'
        },
        {
          label: "设立时间",
          prop: 'establishmentTime',
          span: '8'
        },
        {
          label: "基金规模",
          prop: 'peScale',
          span: '8',
          formatter: (label, value) => {
            if (value == -1) {
              return "";
            } else {
              return this.getMoney(Number(value)/10000) + " 万元";
            }
          },
        },
        {
          label: "基金实缴金额",
          prop: 'totalCapitalPaid',
          span: '8',
          formatter: (label, value) => {
            if (value == -1) {
              return "";
            } else {
              return this.getMoney(Number(value)/10000) + " 万元";
            }
          },
        },
        {
          label: "直投规模",
          prop: 'directInvestScale',
          span: '8',
          formatter: (label, value) => {
            if (value == -1) {
              return "";
            } else {
              return this.getMoney(Number(value)/10000) + " 万元";
            }
          }
        },
        {
          label: "合作基金认缴",
          prop: 'cooperationFundSubscribed',
          span: '8',
          formatter: (label, value) => {
            if (value == -1) {
              return "";
            } else {
              return this.getMoney(Number(value)/10000) + " 万元";
            }
          },
        },
        {
          label: "实缴规模",
          prop: 'cooperationFundPaid',
          span: '8',
          formatter: (label, value) => {
            if (value == -1) {
              return "";
            } else {
              return this.getMoney(Number(value)/10000) + " 万元";
            }
          }
        },        
        {
          label: "合作基金已投金额",
          prop: 'cooperationFundInvested',
          span: '8',
          formatter: (label, value) => {
            if (value == -1) {
              return "";
            } else {
              return this.getMoney(Number(value)/10000) + " 万元";
            }
          }
        },
        {
          label: "金投出资比例",
          prop: 'capitalRatio',
          span: '8',
          unit: '%'
        },
        {
          label: "基金管理人",
          prop: 'managerName',
          span: '8'
        },        
        {
          label: "其他合伙人实缴额",
          prop: 'otherCapitalPaid',
          span: '8',
          formatter: (label, value) => {
            if (value == -1) {
              return "";
            } else {
              return this.getMoney(Number(value)/10000) + " 万元";
            }
          }
        },
        {
          label: "其他合伙人认缴额",
          prop: 'otherCapitalSubscribed',
          span: '8',
          formatter: (label, value) => {
            if (value == -1) {
              return "";
            } else {
              return this.getMoney(Number(value)/10000) + " 万元";
            }
          }
        },
        {
          label: "投后报告周期",
          prop: "manageCycleStr",
          span: '8'
        },
        {
          label: "基金管理人名称",
          prop: 'managerName',
          span: '8',
        },        
        {
          label: "成立时间",
          prop: 'manager',
          propInner: 'establishmentTime',
          span: '8',
        },
        {
          label: "所在地区",
          prop: 'manager',
          propInner: 'region',
          span: '8'
        },
        {
          label: "所在地址",
          prop: 'manager',
          propInner: 'address',
          span: '8',
        },
        {
          label: "纳税识别号",
          prop: 'manager',
          propInner: 'creditCode',
          span: '8',
        },
        {
          label: "基金协会编码",
          prop: 'manager',
          propInner: 'orgCode',
          span: '8',
        },
        {
          label: "联系人",
          prop: 'manager',
          propInner: 'contactPerson',
          span: '8',
        },
        {
          label: "联系号码",
          prop: 'manager',
          propInner: 'contactInfo',
          span: '8',
        },{
          label: "职务信息",
          prop: 'manager',
          propInner: 'duty',
          span: '24',
        }
      ],
      formConfig: {
        infoTitle: "基本信息",
        infoContent: [
          {
            title: "",
            prop: "basicInfo",
          },
        ],
      },      
    };
  },

  components: {
    CommonDetail,
    InfoContainer,
    BusinessDescriptions,
    InvestEventManage,
    NavigatorBar,
    Usermanage,
    Accessory,
    History,
    Dialogreason,
    Dialog,
    Details,
    Detaillist,
    Item,
  },
  watch: {
    $route: {
      handler() {
        this.id = this.$route.params.id;
        this.onLoad(this.id);
      },
      deep: true,
    },
    data: {
      handler() {
        this.affiliatedgetList();
        this.fdprojectpageList();
      },
    },
    activeName: {
      handler(newName, oldName) {
        if (newName == "third") {
          this.queryEventList();
        }
      },
    },
  },
  created() {
    // this.getprojectDetails();
    this.id = this.$route.params.id
    this.onLoad(this.$route.params.id);
    if(this.$route['query']['active'] && this.$route['query']['active'] == 'list'){
      this.activeName = 'third'
    }
  },
  computed: {
    ...mapGetters(["permission", "userInfo"]),
  },
  methods: {
    goEdit() {
      this.$router.push({ path: `/otherFund/investMainBody/edit/${this.id}` });
    },
    loadingNumber(number){
        api
        .getList({ number: number })
        .then(res => {
          this.history=res.data.data.records.length
          // console.log("loadingNumber")
          // console.log(res.data.data.records.length)

        })
    },

    affiliatedgetList() {
      // 关联子基金未回显
      api.affiliatedgetList({ masterId: this.data.id, bizType: '3'  }).then((res) => {
        // console.log(this.data.id);
        this.affiliateditemDate = res.data.data.records;
      });
    },
    fdprojectpageList() {
      api
        .fdprojectpage({ id: this.data.id, bizType: '3'  })
        .then((res) => {
          // console.log(this.data.id);
          this.associateditemsitemDate = res.data.data;
        });
    },

    // 通过
    quanxian(id, type) {
      // this.passblock = true;
      // this.passtype=type
      this.passdata.id = id;
      this.$refs.reasondialog.showblock(type);
    },
    //确定通过或退回
    passcheck(data, type) {
      if (type == "change") {
        // 变更
        api.change({ id: data.id, reason: data.auditAdvise }).then((res) => {
          this.$router.push({ path: `/otherFund/investMainBody/edit/${res.data.data}` });
        });
      } else {
        let params = {
          auditAdvise: data.auditAdvise,
          pass: type== 'true'?true: false,
          auditState: type == 'true'?2: 3,
          id: this.id
        }
        api.auditpass(params).then((res) => {
          this.onLoad(this.$route.params.id);
          this.$message({
            type: "success",
            message: res.data.msg,
          });
        });
      }
    },
    onLoad(id) {
      api
        .detail({ id: id })
        .then(async (res) => {
          let setData = {
            ...res.data.data,
            // manageCycleStr:res.data.data.manageCycle == -1?'':
            auditLog:
              res.data.data.auditLog == ""
                ? ""
                : JSON.parse(res.data.data.auditLog),
          };
          if (res.data.data.manageCycle == -1) {
            setData.manageCycle = "";
            setData.manageCycleStr = ''
          }else {
            setData.manageCycleStr =  await this.queryDict(`${setData.manageCycle}`, '/api/blade-system/dict-biz/dictionary?code=reportcycle_managecycle')
          }
          setData.auditStateStr = await this.queryDict(setData.auditState, '/api/blade-system/dict-biz/dictionary?code=audit_state')
          this.data = setData
          this.loadingNumber(res.data.data.number)
        })
        .catch((res) => {
        });
    },
    queryEventList() {
      let self = this;
      let params = {
        projectId: this.$route.params.id,
        // auditState: 2,
        firstNum: 0,
        num: 100,
      };

      // 不是基金对接人只能拿到审核通过的数据
      // if (this.userInfo.user_id == this.data.managerUser) {
      //   delete params.auditState;
      // }
      queryEventLists(params).then((res) => {
        // console.info(res, 'eventinvest')
        if (res["data"]["code"] == "200") {
          if (res["data"]["data"]["records"]["length"] > 0) {
            self.eventList = res["data"]["data"]["records"];
            self.eventList.map((item) => {
              item["eventName"] = `${item["projectName"]}-${
                item["eventType"] == 0
                  ? "股权投资"
                  : item["eventType"] == 1
                  ? "股权退出"
                  : "分红"
              }`;
              item.auditStateLabel =
                item.auditState == 0
                  ? "待提交"
                  : item.auditState == 1
                  ? "审核中"
                  : item.auditState == 2
                  ? "审核通过"
                  : "-";
            });
          }
        }
      });
    },
    goEventDetail(row) {
      // 路由跳转详情页
      this.$router.push({
        path: `/fund/investEventManage/detail/${row["id"]}`,
        query: {
          eventType: row["eventType"],
        },
      });
    },
    warningblock() {
      this.$refs.dialogpass.showblock();
      // this.dialogVisible = true;
    },
    historyHome() {
      this.$refs.history.showhide(this.data.number);
    },
    bankhistory(id) {
      // console.log(id)
      this.onLoad(id);
      this.$router.push({ path: `/otherFund/investMainBody/detail/${id}` });
    },
    edit(id) {
      this.$router.push({ path: `/otherFund/investMainBody/edit/${id}` });
    },

    //
    changes(id) {
      this.passdata.id = id;
      this.$refs.reasondialog.showblock("change");
    },
    checkcontract(id) {
      // console.log(id)
      // this.$router.push({ path: `/zd/contractmanage/contractDetail/${id}` });
      this.$router.push({
        path: "/zd/contractmanage/contractDetail/",
        query: { id: id },
      });
    },
    checkproject(id) {
      // console.log(id)
      this.$router.push({ path: `/zd/placement/detail/${id}` });
    },
    updatastate(type) {
      //examine ture  审批  false 审核
      let that = this;
      if (type) {
        this.$confirm("是否确定提交审核?", "操作确认", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            api
              .submitWorkflow(this.data.id)
              .then((res) => {
                this.$alert(
                  "数据已同步至OA系统，请您前往OA工作流中查看",
                  "信息提示",
                  {
                    confirmButtonText: "确定",
                    callback: (action) => {
                      this.$message({
                        type: "info",
                        message: "请您前往OA工作流中查看",
                      });
                    },
                  }
                );
                this.onLoad(this.$route.params.id);
              })
              .catch((res) => {
                console.log(res);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      } else {
        this.$confirm("是否确定提交审核?", "操作确认", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.butshengheloading = true;
            api
              .submitaudit(this.data.id)
              .then((res) => {
                this.butshengheloading = false
                this.$message({
                  type: "success",
                  message: res.data.msg,
                });
                this.onLoad(this.$route.params.id);
              })
              .catch((res) => {
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      }
    },

    auditNext(id, type) {
      this.passdata.id = id;
      this.$refs.reasondialog.showblock(`${type}`);      
    },

  },
};
</script>

<style lang="scss" scoped>
  .bottom-container{
    width: 100%;
    height: 70px;
    position: fixed;
    // z-index: 1000;
    bottom: 0px;
    left: 0px;
    z-index: 1000;
    background-color: #fff;
    box-shadow: 0px -8px 10px rgba(0, 0, 0 , 0.05);
    .button-container{
      width: 93%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
.masterfundDetail {
  .bankdetail_title {
    background: #fff;
    padding-top: 25px;
    padding-bottom: 25px;
  }
  .history {
    position: absolute;
    top: 50%;
    right: 15px;
    display: flex;
    justify-content: center;
    z-index: 20;
    flex-direction: row;
    .history_content {
      width: 100px;
      font-size: 14px;
      cursor: pointer;
      height: 45px;
      display: flex;
      flex-direction: row;
      // justify-content: center;
      background: #409eff;
      line-height: 45px;
      color: #fff;
      // text-align: right;
      // padding-right: 15px;
      border-radius: 10px 0 0 10px;
      .imagehistory {
        text-indent: 5px;
        width: 35px;
        display: flex;
        justify-content: center;
        margin-right: 8px;
        flex: 1;
      }
      .text_history {
        flex: 2;
      }
    }
  }
  .banktail_ {
    width: 97%;
    min-width: 1100px;
    margin: 0 auto;
  }
  .bank_nameblock {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    .bankname {
      font-size: 18px;
      font-weight: bolder;
    }
    .changeblock {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .historyclass {
        background: #19be6b;
        padding: 5px 10px;
        font-size: 10px;
        border-radius: 0 10px 10px 0;
        margin-right: 10px;
        color: #fff;
      }
      .reds {
        background: #f56c6c;
      }
      .orange {
        background: #fec03d;
      }
    }
  }
  .comment-container {
    margin-top: 20px;
    /deep/.detail-one {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
    /deep/.comment-container {
      margin-top: 0 !important;
    }
  }
  .bankcontent {
    position: relative;
    margin: 20px 0;
    .el-col {
      margin-bottom: 0px;
    }
    .grid_content {
      line-height: 35px;
      color: #333333;
      font-size: 14px;
      // margin-bottom: 5px;
      .el-form-item {
        margin-bottom: 0px;
      }

      .banktitle_content {
        color: #999999;
        margin-right: 15px;
      }
      .shstate {
        display: flex;
        flex-direction: row;
        text-align: center;
        justify-content: right;
        .list_top {
          flex: 1;
        }
        .towlist_top {
          text-align: right;
        }
        // .list_top:nth-last-of-type(1){
        //  text-align: right;
        // }

        .stateTop {
          color: rgb(187, 185, 185);
          text-indent: 12px;
        }
        .stateTop + div {
          color: #666666;
          font-size: 20px;
        }
        .stateTopdiv::before {
          content: "";
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 5px;
        }
      }
      .data_ {
        margin-top: 25px;
        text-align: right;
        .stateTop {
          color: rgb(187, 185, 185);
        }
        .stateTop + div {
          font-size: 20px;
          font-weight: bolder;
        }
      }
    }
  }
}
  .project-name{
    // overflow: hidden;
    // white-space: nowrap;
    // text-overflow: ellipsis;
  }
  .project-name:hover{
    color: #409EFF;
    cursor: pointer;
  }
  .project-title{
    color: #333;
    font-size: 18px;
    font-weight: bold;
  }
  .project-status{
    .status-title{
      text-align: right;
      font-family: '微软雅黑', sans-serif;
      font-weight: 400;
      color: #999999;
      font-size: 16px;
    }
    .status-content{
      text-align: right;
      font-family: '微软雅黑', sans-serif;
      font-weight: 400;
      color: #666666;
      font-size: 20px;
    }
  }
  .stateTopdiv::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
  }
  .color_0::before {
      background: #fec03d;
  }
  .color_1::before {
      background: #409eff;
  }
  .color_2::before {
      background: #51d351;
  }
  .color_3::before {
      background: #F56C6C;
  }
  .color_4::before {
      background: #F56C6C;
  }
  .top-line{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  .changeblock {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .historyclass {
      background: #19be6b;
      padding: 5px 10px;
      font-size: 10px;
      border-radius: 0 10px 10px 0;
      margin-right: 10px;
      color: #fff;
    }
    .reds {
      background: #f56c6c;
    }
    .orange {
      background: #fec03d;
    }
  }
.warningblock {
  cursor: pointer;
  color: rgb(197, 192, 192);
}
.box_card {
  width: 100%;
  box-shadow: 1px 1px 5px #ddd;
  margin: 20px 0;
  .demo-basic {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 13px;
  }
}
.autilog {
  display: flex;
  flex-direction: column;
}
.warningtext {
  color: rgb(197, 192, 192);
  font-size: 14px;
}
.masterfundDetail .el-tabs__item.is-active {
  background: none;
}
.box_cards {
  height: 450px;
  overflow-y: auto;
}
.passblocksblock {
  // margin-top: 25px;
  text-align: right;
}

.checkcontract {
  cursor: pointer;
}
.detil_row {
  display: inline-block;
}
/deep/.el-form-item__label {
  color: #999999;
}
/deep/.el-tabs__header {
  margin: 0px;
}
.informationxm {
  margin-top: 20px;
}
.form_wrapper {
  height: 100%;
  // margin: 0;
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(233, 233, 233, 1);
  border-radius: 10px;
  background-color: #fff;

  .form_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 0px;
    height: 60px;
    background-color: rgba(249, 249, 249, 1);
    padding: 0 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: 1px rgba(233, 233, 233, 1) solid;

    .form_header_name {
      font-weight: 700;
      color: #333;
      font-size: 16px;
    }
    .form_header_remarks {
      color: #999999;
      font-size: 14px;
      .red_color {
        color: #ff3b30;
      }
    }
  }
  .form_content {
    padding: 0px 50px 30px;
  }
}
.label_name {
  font-weight: 900;
  color: #666666;
  position: relative;
  margin: 30px 0;
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: -15px;
    transform: translate(0, -50%);
    height: 18px;
    width: 6px;
    background-color: #409eff;
  }
}
/deep/.banktail_ .el-tabs__item {
  font-size: 18px;
  font-weight: bolder;
  margin-bottom: 10px;
}
/deep/ .el-table th {
  background: #fff;
  color: #333;
}
.blue-word{
    color: #409eff;
    cursor: pointer;
}
</style>
